import { V3Button } from "../Button"
import { V3ButtonColor } from "../Button/V3Button.types"
import { ModalIconSegment, V3ModalIconSegmentVariant } from "../ReusableStyledComponents/ModalIconSegment"
import { RightAlignPanel } from "../ReusableStyledComponents/RightAlignPanel"
import { V3CaptionGrey48 } from "../ReusableStyledComponents/V3CaptionGrey48"
import { VerticalSpacing } from "../VerticalSpacing"
import { RoundedBoxCTA } from "./SharedComponents/RoundedBoxCTA"

interface V3ModalAddSourceFutureContentProps {
    onCloseHandler: () => void
    onBackHandler: () => void,
}

export const V3ModalUACSpotify = ({ onCloseHandler, onBackHandler }: V3ModalAddSourceFutureContentProps) => {
    return <>
        <ModalIconSegment
            variant={V3ModalIconSegmentVariant.warning}
        />
        <VerticalSpacing bottom={24}>
            <V3CaptionGrey48>Unfortunately, Spotify makes it technically impossible to import your podcasts. However, if a podcast is on Spotify, it's usually also available on other platforms or via RSS.</V3CaptionGrey48>
        </VerticalSpacing>
        <VerticalSpacing bottom={12}>
            <V3CaptionGrey48><strong>Here is a quick guide:</strong></V3CaptionGrey48>
        </VerticalSpacing>
        <VerticalSpacing bottom={24}>
            <RoundedBoxCTA
                text="How to add Spotify content"
                href="https://authory.com/help/en/articles/8343988-how-to-import-podcasts-from-spotify"
            />
        </VerticalSpacing>
        <VerticalSpacing top={24}>
            <RightAlignPanel>
                {
                    !!onBackHandler && <div>
                        <V3Button
                            text="Back"
                            color={V3ButtonColor.secondary}
                            onClick={onBackHandler}
                        />
                    </div>
                }
                <div>
                    <V3Button
                        text="Close"
                        onClick={onCloseHandler}
                    />
                </div>
            </RightAlignPanel>
        </VerticalSpacing>
    </>
}